import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

let fadeObserver
let revealObserver

export const onClientEntry = () => {
  if (typeof document === "undefined") return
  document.documentElement.classList.add("js")
}

export const onRouteUpdate = () => {
  if (typeof document === "undefined") return

  // =========================
  // 前回の監視を確実に破棄（Gatsbyはcleanupを呼ばない）
  // =========================
  if (fadeObserver) fadeObserver.disconnect()
  if (revealObserver) revealObserver.disconnect()

  // =========================
  // 1) fadeInUp
  // =========================
  const fadeTargets = document.querySelectorAll(".fadeInUp")
  fadeObserver = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        entry.target.classList.add("on")
        entry.target.classList.add("is-jump") // ←必要なら残す
        obs.unobserve(entry.target)
      })
    },
    { threshold: 0.1 }
  )
  fadeTargets.forEach(el => fadeObserver.observe(el))

  // =========================
  // 2) js-reveal
  // =========================
  const revealTargets = document.querySelectorAll(".js-reveal")
  revealObserver = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        requestAnimationFrame(() => entry.target.classList.add("is-in"))
        obs.unobserve(entry.target)
      })
    },
    { threshold: 0.25 }
  )
  revealTargets.forEach(el => revealObserver.observe(el))

  // =========================
  // 3) comVisual（毎回必ず発火）
  // =========================
  const comVisuals = document.querySelectorAll(".comVisual")
  comVisuals.forEach(el => {
    el.classList.remove("is-in")
    void el.offsetHeight
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.classList.add("is-in")
      })
    })
  })

  // =========================
  // 4) TOPのKV（.indexPage .mainVisual）毎回必ず発火
  // =========================
  // TOP KV（毎回フェードインさせる）
  const topKV = document.querySelector(".indexPage .topKV")
  if (topKV) {
    topKV.classList.remove("is-in")
    void topKV.offsetHeight
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        topKV.classList.add("is-in")
      })
    })
  }

  // =========================
  // 5) recruitPage 全体の紙吹雪（毎回確実にリスタート）
  // =========================
  const recruit = document.querySelector(".recruitPage")
  if (recruit) {
    recruit.classList.remove("is-in")
    void recruit.offsetHeight
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        recruit.classList.add("is-in")
      })
    })
  }
}
